import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useContext } from 'react'; // <-- hier fehlte der Import
import { AuthProvider, AuthContext } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import Login from './pages/Login';
import Tires from './pages/Tires';
import Stock from './pages/Stock';
import Partners from './pages/Partners';
import Dashboard from './pages/Dashboard';
import Cash from './pages/Cash';
import Suppliers from './pages/Suppliers';
import Finance from './pages/Finance';
import Expenses from './pages/Expenses';
import Payroll from './pages/Payroll';
import Users from './pages/Users';
import Navbar from './components/Navbar';



function PrivateRoute({ children }) {
  const { user, ready } = useContext(AuthContext);
  if (!ready) return null;
  return user ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <Router>
      <SnackbarProvider>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/tires" element={<PrivateRoute><Tires /></PrivateRoute>} />
            <Route path="/stock" element={<PrivateRoute><Stock /></PrivateRoute>} />
            <Route path="/partners" element={<PrivateRoute><Partners /></PrivateRoute>} />
            <Route path="/suppliers" element={<PrivateRoute><Suppliers /></PrivateRoute>} />
            <Route path="/cash" element={<PrivateRoute><Cash /></PrivateRoute>} />
            <Route path="/finance" element={<PrivateRoute><Finance /></PrivateRoute>} />
            <Route path="/expenses" element={<PrivateRoute><Expenses /></PrivateRoute>} />
            <Route path="/payroll" element={<PrivateRoute><Payroll /></PrivateRoute>} />
            <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/" element={<Navigate to="/tires" />} />
          </Routes>
        </AuthProvider>
      </SnackbarProvider>
    </Router>
  );
}
